import { ONBOARDING_SCOPES } from 'onboarding-scopes/scopeConstants';
import { isOwned, ownsNone } from './ownershipUtils';
const {
  CMS_ENTERPRISE,
  CMS_PRO,
  CMS_STARTER,
  COMMERCE_ENTERPRISE,
  COMMERCE_PRO,
  MARKETING_ENTERPRISE,
  MARKETING_PRO,
  MARKETING_STARTER,
  OPS_ENTERPRISE,
  OPS_PRO,
  OPS_STARTER,
  SALES_ENTERPRISE,
  SALES_PRO,
  SALES_STARTER,
  SERVICE_ENTERPRISE,
  SERVICE_PRO,
  SERVICE_STARTER
} = ONBOARDING_SCOPES;
export const getOwnsCmsHubEnterprise = scopes => isOwned(scopes, CMS_ENTERPRISE);
export const getOwnsCmsHubPro = scopes => isOwned(scopes, CMS_PRO) && !isOwned(scopes, CMS_ENTERPRISE);
export const getOwnsCmsHubStarter = scopes => isOwned(scopes, CMS_STARTER) && ownsNone(scopes, [CMS_PRO, CMS_ENTERPRISE]);
export const getOwnsMarketingHubEnterprise = scopes => isOwned(scopes, MARKETING_ENTERPRISE);
export const getOwnsMarketingHubPro = scopes => isOwned(scopes, MARKETING_PRO) && !isOwned(scopes, MARKETING_ENTERPRISE);
export const getOwnsMarketingHubStarter = scopes => isOwned(scopes, MARKETING_STARTER) && ownsNone(scopes, [MARKETING_PRO, MARKETING_ENTERPRISE]);
export const getOwnsOpsHubEnterprise = scopes => isOwned(scopes, OPS_ENTERPRISE);
export const getOwnsOpsHubPro = scopes => isOwned(scopes, OPS_PRO) && !isOwned(scopes, OPS_ENTERPRISE);
export const getOwnsOpsHubStarter = scopes => isOwned(scopes, OPS_STARTER) && ownsNone(scopes, [OPS_PRO, OPS_ENTERPRISE]);
export const getOwnsSalesHubEnterprise = scopes => isOwned(scopes, SALES_ENTERPRISE);
export const getOwnsSalesHubPro = scopes => isOwned(scopes, SALES_PRO) && !isOwned(scopes, SALES_ENTERPRISE);
export const getOwnsSalesHubStarter = scopes => isOwned(scopes, SALES_STARTER) && ownsNone(scopes, [SALES_PRO, SALES_ENTERPRISE]);
export const getOwnsServiceHubEnterprise = scopes => isOwned(scopes, SERVICE_ENTERPRISE);
export const getOwnsServiceHubPro = scopes => isOwned(scopes, SERVICE_PRO) && !isOwned(scopes, SERVICE_ENTERPRISE);
export const getOwnsServiceHubStarter = scopes => isOwned(scopes, SERVICE_STARTER) && ownsNone(scopes, [SERVICE_PRO, SERVICE_ENTERPRISE]);
export const getOwnsCommerceHubEnterprise = scopes => isOwned(scopes, COMMERCE_ENTERPRISE);
export const getOwnsCommerceHubPro = scopes => isOwned(scopes, COMMERCE_PRO) && !isOwned(scopes, COMMERCE_ENTERPRISE);